export default `

    /*========= remove default HTML5 input search X button ==========*/
    /* clears the ‘X’ from Internet Explorer */
    
    /* clears the 'X' from Internet Explorer */
    input[inputmode=search]::-ms-clear,
    input[inputmode=search]::-ms-reveal {
        display: none;
        width: 0;
        height: 0;
    }
    
    /* clears the 'X' from Chrome */
    input[inputmode="search"]::-webkit-search-decoration,
    input[inputmode="search"]::-webkit-search-cancel-button,
    input[inputmode="search"]::-webkit-search-results-button,
    input[inputmode="search"]::-webkit-search-results-decoration {
        display: none !important;
    }
    /*===============================================================*/

    /* DEPRECATED ?? */
    .validationMessage {
        display:block;line-height:inherit;
        color: red;
    }
    
    
    /*===== CUSTOM LOADING ICON IN LOADING DIALOG ======*/
    
    [data-kta2-custom-loading] .loading-content {
        
        display: table;
    }
    
    [data-kta2-custom-loading] .loading-content img {
        width:48px; height:48px;
        display: table-cell;
        vertical-align: middle;
    }
    
    [data-kta2-custom-loading] .loading-content span {
        display: table-cell;
        vertical-align: middle;
        width:80%;
        padding-left:6px;
    }
    
    /*===================================================*/
    
    .kta20-sub-header {
        padding:var(--ion-padding, 8px);
        background-color:var(--ion-color-secondary);
        text-align:center;
    }
    
    .kta20-align-middle-center {
        with:100%;height: 0px;overflow:visible;text-align: center;position: absolute;margin:auto;top:0;bottom:0;right:0;left:0;
    }
    
    .kta20-spinner-top {
        color:var(--ion-color-primary);
        width: 100%;
        margin-top: 10px;
    }
    
    .kta20-centered-in-parent { /* parent must have height 100% */
        position:relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;